<template>
  <v-container class="mx-auto notFound-container">
    <div v-if="!isWrongUser && !isWrongUserToAdvancedSign"
         class="text-center notFound-title"
    >
      {{ $t('Error.views.NotFound.errorTitle') }}
    </div>

    <div v-if="customMessage" class="text-center mt-2">
      <h3>{{ $t(`Error.views.NotFound.${customMessage}`, { currentUserFullName }) }}</h3>
    </div>
    <div v-else class="text-center mt-2">
      <h3>{{ $t('Error.views.NotFound.title2') }}</h3>
    </div>

    <div v-if="isWrongUser || isWrongUserToAdvancedSign" class="text-center mt-11">
      <v-row>
        <v-col class="d-flex justify-end">
          <AppButton v-if="isWrongUser"
                     color="primary"
                     :to="{ name: SIMPLE_SIGNATURE_ROUTE_NAME, params: paramsRouteSigningView }"
          >
            {{ $t('Error.views.NotFound.btnOk') }}
          </AppButton>
          <AppButton v-else
                     color="primary"
                     :to="{ name: LOGOUT_ROUTE_NAME, params: {redirectProps: {returnRoute: paramsRouteSigningAdvancedView }} }"
          >
            {{ $t('Error.views.NotFound.btnOk') }}
          </AppButton>
        </v-col>
        <v-col class="d-flex justify-start">
          <AppButton color="secondary"
                     :to="{name: isAuthent ? ROOMS_ROUTE_NAME : SIGN_IN_ROUTE_NAME, params: { locale: localeLanguage } }"
          >
            {{ $t('Error.views.NotFound.btnKo') }}
          </AppButton>
        </v-col>
      </v-row>
    </div>
    <div v-else class="text-center mt-11">
      <AppButton color="primary"
                 :to="{name: isAuthent ? ROOMS_ROUTE_NAME : SIGN_IN_ROUTE_NAME, params: { locale: localeLanguage } }"
      >
        {{ $t('Error.views.NotFound.btn') }}
      </AppButton>
    </div>
  </v-container>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'
import i18n from '@/plugins/i18n'
import {
  ROOMS_ROUTE_NAME,
  SIGN_IN_ROUTE_NAME,
  SIMPLE_SIGNATURE_ROUTE_NAME,
  LOGOUT_ROUTE_NAME,
  SIGNING_VIEW_ROUTE_NAME,
} from '@/router'
import store from '@/store/'

export default {
  name: 'NotFound',
  components: { AppButton },
  props: {
    customMessage: {
      type: String,
      required: false,
    },
    paramRoute: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      ROOMS_ROUTE_NAME,
      SIGN_IN_ROUTE_NAME,
      SIMPLE_SIGNATURE_ROUTE_NAME,
      LOGOUT_ROUTE_NAME,
    }
  },
  computed: {
    isAuthent () {
      // Any already auth user _at least_ has a profile id.
      return !!store.getters['user/currentUserId']
    },
    currentUserFullName () {
      return store.getters['user/profileFullName']
    },
    localeLanguage () {
      return i18n.global.locale.value
    },
    isWrongUser () {
      return this.customMessage === 'ERR_WRONG_USER_LOGGED_IN'
    },
    isWrongUserToAdvancedSign () {
      return this.customMessage === 'ERR_WRONG_SIGNER'
    },
    paramsRouteSigningView () {
      const params = this.paramRoute
      params.withoutApiToken = true
      return params
    },
    paramsRouteSigningAdvancedView () {
      const route = {}
      route.name = SIGNING_VIEW_ROUTE_NAME
      route.params = this.paramRoute
      return route
    },
  },
}
</script>

<style scoped>
  .notFound-container {
    max-width: 1100px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .notFound-title {
    font-size: 48px;
    font-weight: bold;
  }
</style>
